import { AvailabilityBlockState } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { localizeEnum } from '@mews-commander/utils';

interface Alert {
    title: JSX.Element;
    description: JSX.Element;
}

export const getAvailabilityBlockStateChangedSuccessAlert = (newState: AvailabilityBlockState): Alert => {
    const newStateString = localizeEnum('AvailabilityBlockState', newState).toLowerCase();

    const description = titleMap[newState];

    return {
        title: lt('AvailabilityBlockStateChanged', { blockState: newStateString }),
        description: lt(description),
    };
};

const titleMap = {
    [AvailabilityBlockState.Inquired]: TextKey.AvailabilityBlockStateInquiredHint,
    [AvailabilityBlockState.Optional]: TextKey.AvailabilityBlockStateOptionalHint,
    [AvailabilityBlockState.Confirmed]: TextKey.AvailabilityBlockStateConfirmedHint,
    [AvailabilityBlockState.Canceled]: TextKey.AvailabilityBlockStateChangedToCancelledDesc,
};
